import { Standard } from '@getvim/vim-connect';

const demographics: Standard.Entities.PatientDemographics = {
  firstName: 'Jane',
  lastName: 'Taylor',
  dateOfBirth: '1992-07-12',
  address: {
    zipCode: '60601',
  },
};

const insurance: Standard.Entities.PatientInsurance = {
  memberId: '200000002',
  ehrInsurance: 'mock-payer',
};

const patientId: string = 'test_mock-payer_20260212120732';

export const janeTaylor: Standard.Events.PatientInContextPayload = {
  patientId,
  demographics,
  insurance,
};
